<template>
  <div class="page flex-col">
    <div class="block_1 flex-col justify-end">
      <!-- <div class="box_1 flex-row">
        <img
          class="image_1"
          referrerpolicy="no-referrer"
          src="./assets/img/SketchPng5eb7835fc957042f4b02048930b15033b02aadc08574d830df2c060761b9879a.png"
        />
        <img
          class="image_2"
          referrerpolicy="no-referrer"
          src="./assets/img/SketchPng4b858c76b9deb5b3941827f27d1c8ac1b586ba98eec1392060201b04c690af4c.png"
        />
        <span class="text_1">自由随心·Al随行·慧安智远</span>
        <span class="text_2" @click="PageIndex">首页</span>
       <span class="text_3" @click="sdycxq">产品方案</span>
        <span class="text_4" @click="case_presentation">案例展示</span>
        <span class="text_5" @click="news_information">新闻动态</span>
        <span class="text_6" @click="guanyuhuian">关于慧安</span>
      </div> -->

      <div class="box_1 flex-row items-center"> <!-- 新增items-center确保垂直居中 -->
        <img class="image_1" referrerpolicy="no-referrer"
          src="./assets/img/SketchPng5eb7835fc957042f4b02048930b15033b02aadc08574d830df2c060761b9879a.png" />
        <img class="image_2" referrerpolicy="no-referrer"
          src="./assets/img/SketchPng4b858c76b9deb5b3941827f27d1c8ac1b586ba98eec1392060201b04c690af4c.png" />
        <span class="text_1">自由随心·Al随行·慧安智远</span>
        <span class="text_2" @click="PageIndex">首页</span>
        <!-- <span class="text_3" @click="sdycxq">产品方案</span> -->

        <div class="dropdown-container" @mouseenter="showDropdown = true" @mouseleave="showDropdown = false">
          <span class="text_3 cursor-pointer">产品方案</span>
          <div class="dropdown-menu" v-if="showDropdown">
            <div class="dropdown-item" @click="handleCaseClick('three_narcotic_drug_vehicle')">三代麻精药品车</div>
            <div class="dropdown-item" @click="handleCaseClick('two_narcotic_drug_vehicle')">二代麻精药品车</div>
            <div class="dropdown-item" @click="handleCaseClick('consumables_cabinet')">高值耗材柜</div>
            <div class="dropdown-item" @click="handleCaseClick('ai_recycling_bin')">AI智能回收箱</div>
            <div class="dropdown-item" @click="handleCaseClick('hydrogenperoxide_disinfection_machine')">过氧化氢消毒机</div>
            <div class="dropdown-item" @click="handleCaseClick('transfer_bed')">电动转运床</div>

          </div>
        </div>

        <span class="text_4" @click="case_presentation">案例展示</span>
        <span class="text_5" @click="news_information">新闻动态</span>
        <span class="text_6" @click="guanyuhuian">关于慧安</span>
      </div>

      <div class="box_2 flex-row"><div class="group_1 flex-col"></div></div>
    </div>
    <div class="block_2 flex-col"></div>
    <div class="block_3 flex-col">
      <span class="text_7">新闻动态</span>
      <div class="block_4 flex-row">
        <!-- <div class="group_2 flex-col"></div> -->
          <img class="group_3" referrerpolicy="no-referrer" src="./assets/img/sy7.png" />

        <div class="text-group_1 flex-col justify-between">
          <span class="text_8">J9展位实况直击！第三代麻精车被围观摩</span>
          <span class="text_9">
            开展首日J9展位盛况超预期——第三代麻精药品车前围满探究目光，AI回收箱的智能提示音此起彼伏…
          </span>
        </div>
        <span class="text_10">6.20</span>
      </div>
      <div class="block_5 flex-row">
        <div class="box_3 flex-col"></div>
        <div class="text-group_2 flex-col justify-between">
          <span class="text_11">2025年湖州嘉兴麻醉学学术年会暨临床麻醉质控年会</span>
          <span class="text_12">
            2025年7月19-20日，江苏慧安智远智能医疗科技有限公司将携最新研发的“麻精药品智能管理系统”亮相2025年湖州嘉兴两市麻醉学学术年会暨临床麻醉质控年会。
          </span>
        </div>
        <span class="text_13">7.19</span>
      </div>
      <div class="block_6 flex-row">
        <!-- <div class="group_3 flex-col"></div> -->
          <img class="group_3" referrerpolicy="no-referrer" src="./assets/img/sy6.png" />

        <div class="text-group_3 flex-col justify-between">
          <span class="text_14">苏州市医学会组织召开第十七次麻醉学术会议</span>
          <span class="text_15">
            2025年8月1日-8月3日，苏州市医学会组织召开第十七次麻醉学术会议暨苏州市麻醉专业医疗质量控制中心学术会议。会议在苏州市国际会议酒店举行。届时，江苏慧安智远将携麻精药品智能管理系统惊艳亮相~！
          </span>
        </div>
        <span class="text_16">8.01</span>
      </div>
      <div class="block_7 flex-col">
        <div class="text-wrapper_1 flex-row">
          <span class="text_17">公司信息</span>
          <span class="text_18">二维码</span>
          <span class="text_19">商务合作</span>
        </div>
        <div class="image-wrapper_1 flex-row justify-between">
          <img
            class="image_3"
            referrerpolicy="no-referrer"
            src="./assets/img/SketchPng1c0a871b3fb97b29a5d07e5b71ab2c9223c1b2d4b7269d3443356771d6bdf9aa.png"
          />
          <img
            class="image_4"
            referrerpolicy="no-referrer"
            src="./assets/img/SketchPng1c0a871b3fb97b29a5d07e5b71ab2c9223c1b2d4b7269d3443356771d6bdf9aa.png"
          />
          <img
            class="image_5"
            referrerpolicy="no-referrer"
            src="./assets/img/SketchPng1c0a871b3fb97b29a5d07e5b71ab2c9223c1b2d4b7269d3443356771d6bdf9aa.png"
          />
        </div>
        <div class="block_8 flex-row">
          <span class="paragraph_1">
            江苏慧安智远智能医疗科技有限公司
            <br />
            <br />
            地址：无锡市惠山区惠山大道1719-5号二层B区&nbsp;
            <br />
            电话：0510-83582015
            <br />
            邮箱：huianzhiyuan&#64;qq.com
            <br />
            官网：www.hilears.com&nbsp;
            <br />
          </span>
          <div class="image-text_1 flex-col justify-between">
            <div class="image-wrapper_2 flex-col">
              <img
                class="image_6"
                referrerpolicy="no-referrer"
                src="./assets/img/SketchPng6d89f0dbceb8cf2835772a0f780d8d18a85d8ad63f161fa6700239ef2ee1b0b1.png"
              />
            </div>
            <span class="text-group_4">
              关注公众号：HILEARS和尔思
              <br />
            </span>
          </div>
          <span class="text_20">卢先生&nbsp;&nbsp;0510-83582015</span>
        </div>
        <div class="text-wrapper_2 flex-row">
          <span class="text_21">
          Copyright&nbsp;©&nbsp;&nbsp;2025&nbsp;-&nbsp;forever&nbsp;&nbsp;江苏慧安智远智能医疗科技有限公司所有
          <a onclick="window.open('http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32020602001022')">苏公网安备
            32020602001022号&nbsp;&nbsp;</a>
          <a onclick="window.open('https://beian.miit.gov.cn')">苏ICP备20031743号-1</a>

        </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import sy6Img from './assets/img/sy6.png'
// import sy7Img from './assets/img/sy7.png'
export default {
  data() {
    return {
        // 新增下拉菜单控制变量
      showDropdown: false,
      constants: {}
    };
  },
  methods: {
     // 新增下拉菜单点击处理方法
    handleCaseClick(type) {
      // 根据不同案例类型跳转到不同页面
      this.$router.push(`/${type}`);
      // 关闭下拉菜单
      this.showDropdown = false;
    },
       PageIndex() {
      this.$router.push('/PageIndex')
    },
     sdycxq() {
      this.$router.push('/three_narcotic_drug_vehicle')
    },
    guanyuhuian() {
      this.$router.push('/guanyuhuian')
    },
    case_presentation() {
      this.$router.push('/case_presentation')
    },
    news_information() {
      this.$router.push('/news_information')
    },
  }
};
</script>
<style scoped lang="css" src="./assets/index.css" />
<style>
/* 修改下拉菜单样式 */
.dropdown-container {
  position: relative;
  display: inline-flex;
  /* 使用inline-flex保持与其他元素对齐 */
  align-items: center;
  /* 确保文本垂直居中 */
  height: 50%;
  /* 占满父容器高度 */
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  /* 从容器底部开始显示 */
  left: 0;
  background-color: white;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  min-width: 160px;
  z-index: 1000;
  margin-top: 5px;
  /* 与主菜单保持一点距离 */
  padding: 8px 0;
  animation: fadeIn 0.2s ease-in-out;
}

/* 调整菜单项样式 */
.dropdown-item {
  padding: 10px 16px;
  color: #1d1f24;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
}

/* 修复父容器对齐 */
.box_1 {
  align-items: center;
  /* 确保所有子元素垂直居中 */
  display: flex;
}

/* 保持其他样式不变 */
.text_4 {
  /* 确保文本本身垂直居中 */
  display: inline-flex;
  align-items: center;
  height: 100%;
}

/* 动画效果 */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-5px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
